import s from './TopSpecialists.module.scss';
import {ReactComponent as Star} from 'images/new-icons/rating-start.svg';
import Button from 'components/shared/Button';
import useGetServicesTeamsByServiceId from 'sdk/hooks/booking/useGetServicesTeamsByServiceId';
import useGetSpecialistsBySalonId from 'sdk/hooks/salon/useGetSpecialistsBySalonId';
import {useNavigate} from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import {useTranslation} from 'react-i18next';

import SpecialistRating from 'components/shared/SpecialistRating';
import useGetSpecialistRating from 'sdk/hooks/salon/useGetSpecialistRating';

const SpecialistRatingContainer = ({ teamId }: { teamId: string }) => {
    const { data } = useGetSpecialistRating(teamId);
    return <SpecialistRating rating={data?.average || 0} count={data?.count} />;
};

const TopSpecialists = ({
                            serviceId,
                            salonId,
                            setSelectedService,
                        }: {
    serviceId?: string;
    salonId?: string;
    setSelectedService?: any;
}) => {
    const {t} = useTranslation() as any
    const navigate = useNavigate();
    const {data: isAuthData} = useIsAuth();
    const {data: specialistsByService} = useGetServicesTeamsByServiceId(serviceId ? [serviceId] : []);
    const {data: specialistsBySalon} = useGetSpecialistsBySalonId(salonId);

    const specialists = serviceId ? specialistsByService : specialistsBySalon;

    const getSpecialistData = (
        specialist: any,
    ): { id: string; full_name: string; avatar: string } => {
        if ('teams' in specialist) {
            return {
                id: specialist.teams.id,
                full_name: specialist.teams.full_name,
                avatar: specialist.teams.avatar,
            };
        }
        return {
            id: specialist.id,
            full_name: specialist.full_name,
            avatar: specialist.avatar,
        };
    };

    const handleBookClick = (specialistId: string) => {
        navigate(`/appointment-booking-spec/salon/${salonId}/specialist/${specialistId}`);
    };

    const specName = (name: string, specialistId: string) => {
        return (
            <>
                <div className={s.spec}>
                    <div className={s.spec_name}>{name}</div>
                    <SpecialistRatingContainer teamId={specialistId} />
                </div>
                <div className={s.action}>
                    <Button
                        className={s.action_button}
                        darkGreen
                        onClick={() => {
                            if (isAuthData?.isAuth) {
                                handleBookClick(specialistId);
                            } else {
                                navigate('/sign-up');
                            }
                        }}
                    >
                        {t('Book')}
                    </Button>
                </div>
            </>
        );
    };

    return (
        <div className={s.container}>
            {specialists?.map(specialist => {
                const data = getSpecialistData(specialist);
                return (
                    <div key={data.id} className={s.card}>
                        {data.avatar && (
                            <img className={s.card_image} src={data.avatar} alt="Specialist Image"/>
                        )}
                        {specName(
                            (data.full_name || '').split(' ')[0],
                            data.id,
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default TopSpecialists;
